var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleEar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 77,
    viewBox: "0 0 164 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5841 21.4417C28.178 15.4931 35.6137 13.5007 39.9684 17.8554L58.5 36.3871C62.8547 40.7417 60.8623 48.1774 54.9137 49.7713L29.599 56.5544C23.6504 58.1483 18.2071 52.705 19.801 46.7565L26.5841 21.4417Z",
    fill: "#E5DCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.387 17.8558C127.741 13.5011 135.177 15.4935 136.771 21.4421L143.554 46.7568C145.148 52.7054 139.705 58.1487 133.756 56.5548L108.441 49.7717C102.493 48.1778 100.5 40.7421 104.855 36.3874L123.387 17.8558Z",
    fill: "#E5DCFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleEar);
export default __webpack_public_path__ + "static/media/purple_ear.3f384a47c8d2005db771f9fbb3f9162b.svg";
export { ForwardRef as ReactComponent };